const UPDATABLE_PROVIDERS = ['applePay', 'paypal'];

export const updateBraintreeAmount = (braintree, amount) =>
  UPDATABLE_PROVIDERS.forEach((provider) =>
    braintree.updateConfiguration(provider, 'amount', amount)
  );
